module.exports = __webpack_public_path__ + "static/media/illumina-logo.45e461ed.svg";